import Vue from 'vue';
import {mapState,mapActions} from 'vuex';
import $ from 'jquery' ;
import { Toast } from 'vant';
import http from '../../utils/config';
import Axios from 'axios';
let Base64 = require('js-base64').Base64;
import { PullRefresh } from 'vant';

Vue.use(PullRefresh);
export default {
  name: 'history',
  data() {
    return {
      lists: [ ]
      // chatAdviceMemberReply:''

    };

  },
  updated(){


  },
  created() {
    this.getList()
  },
  methods: {
    ...mapActions('bot', ['add','postfile','findList','listDetail']),
    todetail(chatAdviceId){
      this.$router.push({
        name: 'QuestionDetail',
        query: {
          id:chatAdviceId
        }
      })

    },
    back() {
      this.$router.go(-1)
    },
   getList(){
    this.findList({chatAdviceOpenid:localStorage.getItem('openId'),rebotBelongTo:localStorage.getItem('productCode')}).then(res=>{
      this.lists=res.data;
    })
   }
  },

};

